<template>
  <div class="home">
 
  
    <a-row type="flex" justify="space-between" class="content" style="height:100%">
    
      <div class="module left" style="height:100%;width:29%">
        <div>
          <component
            v-for="(item,index) in currentComponentList"
            :key="index"
            :class="`componentModlue `+`${item}`+'Modlue'"
            :is="item"
            :ref="item"
          ></component>
        </div>
      </div>
 
      <div class="middle module" style="height:100%;width:41%">
        <component
          v-for="(item,index) in middleComponentList"
          :key="index"
        :class="`componentModlue `+`${item}`+'Modlue'"
          :is="item"
          :ref="item"
        ></component>

        <!-- <div class="middle_top">
            <i>效率进度</i>
            <span class="checkWork">考勤明细</span>
            <div class="flex_bet text-center">
              <div style="width:30%;height:78px;background:rgb(63, 114, 186,0.2);">
                <p style="color:#3D7FFF;font-size:20px;height:39px;line-height:36px">346人</p>
                <p style="color:#fff;font-size:14px;">应出勤数</p>
              </div>
              <div style="width:30%;height:78px;background:rgb(63, 114, 186,0.2);">
                <p style="color:#3D7FFF;font-size:20px;height:39px;line-height:36px">343人</p>
                <p style="color:#fff;font-size:14px;">实际出勤数</p>
              </div>
              <div style="width:35%;height:78px;background: rgb(255, 60, 60,0.4);">
                <p style="color:#fff;font-size:20px;height:39px;line-height:36px">3人</p>
                <p style="color:#fff;font-size:14px">疫情体温异常</p>
              </div>
            </div>
            <p class="m-top">
              <span style="color:#fff;font-size:15px;font-weight:bold;">实发劳资金额：</span>
              <span style="font-weight:bold;color:#3D7FFF;font-size:15px;">6464万</span>
              <span style="font-weight:bold;margin-left:12px;color:#fff;font-size:15px;">实发劳资金额：</span>
              <span style="font-weight:bold;color:#FF833C;font-size:15px;">6464万</span>
            </p>
            <div class="flex_bet m-top" style="height:160px;">
              <div id="chart06" style="height:100%;width:49.5%"></div>
              <div id="chart07" style="height:100%;width:49.5%"></div>
            </div>
        </div>-->
        <!-- <div class="middle_top">
            <i>预警监测</i>
            <div class="flex_bet text-center">
              <div style="width:30%;height:78px;background:rgb(63, 114, 186,0.2);">
                <p style="color:#3D7FFF;font-size:20px;height:39px;line-height:36px">340</p>
                <p style="color:#fff;font-size:14px;">累计预警数</p>
              </div>
              <div style="width:30%;height:78px;background:rgb(63, 114, 186,0.2);">
                <p style="color:#3D7FFF;font-size:20px;height:39px;line-height:36px">337</p>
                <p style="color:#fff;font-size:14px;">已处理预警数</p>
              </div>
              <div style="width:35%;height:78px;background: rgb(255, 60, 60,0.4);">
                <p style="color:#fff;font-size:20px;height:39px;line-height:36px">3</p>
                <p style="color:#fff;font-size:14px">未处理预警数</p>
              </div>
            </div>
            <div style="width: 100%; text-align: center;">
              <li
                class="flex-bet m-top"
                style="color:#95adce;display: flex;justify-content: space-between;text-align: center"
              >
                <span style="flex:1">预警设备</span>
                <span style="flex:1">预警时间</span>
                <span style="flex:1">地点</span>
                <span style="flex:1">类型</span>
              </li>
              <div style="overflow:hidden">
                <div class="animation" style="height:180px">
                  <li class="flex-bet safeData">
                    <span>卸料平台1</span>
                    <span>08/15 14:30</span>
                    <span>1栋卸料处</span>
                    <span style="color:red">设备</span>
                  </li>
                  <li class="flex-bet safeData">
                    <span>卸料平台2</span>
                    <span>08/15 14:30</span>
                    <span>2栋卸料处</span>
                    <span>设备</span>
                  </li>
                  <li class="flex-bet safeData">
                    <span>塔吊1</span>
                    <span>08/15 14:30</span>
                    <span>塔吊A点</span>
                    <span>设备</span>
                  </li>
                  <li class="flex-bet safeData">
                    <span>塔吊2</span>
                    <span>08/15 14:30</span>
                    <span>塔吊B点</span>
                    <span style="color:red">设备</span>
                  </li>
                  <li class="flex-bet safeData">
                    <span>塔吊2</span>
                    <span>08/15 14:30</span>
                    <span>塔吊C点</span>
                    <span>设备</span>
                  </li>
                  <li class="flex-bet safeData">
                    <span>卸料平台2</span>
                    <span>08/15 14:30</span>
                    <span>1栋卸料处</span>
                    <span style="color:red">设备</span>
                  </li>
                  <li class="flex-bet safeData">
                    <span>卸料平台3</span>
                    <span>08/15 14:30</span>
                    <span>1栋卸料处</span>
                    <span style="color:red">隐患</span>
                  </li>
                  <li class="flex-bet safeData">
                    <span>塔吊1</span>
                    <span>08/15 14:30</span>
                    <span>塔吊A点</span>
                    <span>设备</span>
                  </li>
                  <li class="flex-bet safeData">
                    <span>塔吊2</span>
                    <span>08/15 14:30</span>
                    <span>塔吊B点</span>
                    <span style="color:red">设备</span>
                  </li>
                  <li class="flex-bet safeData">
                    <span>塔吊2</span>
                    <span>08/15 14:30</span>
                    <span>塔吊C点</span>
                    <span>设备</span>
                  </li>
                  <li class="flex-bet safeData">
                    <span>卸料平台2</span>
                    <span>08/15 14:30</span>
                    <span>1栋卸料处</span>
                    <span style="color:red">设备</span>
                  </li>
                  <li class="flex-bet safeData">
                    <span>卸料平台3</span>
                    <span>08/15 14:30</span>
                    <span>1栋卸料处</span>
                    <span style="color:red">隐患</span>
                  </li>
                </div>
              </div>
            </div>
        </div>-->
      </div>
        <div style="height:100%;width:29%">
          <component
            v-for="(item,index) in rigthComponentList"
            :key="index"
            :class="`componentModlue `+`${item}`+'Modlue'"
            :is="item"
            :ref="item"
          ></component>
      </div>
    </a-row>
  </div>
</template>

<script>
import safe from "./safe.vue";
import worksite from "./worksite.vue";
import progressData from "./progress.vue";
import warning from "./warning.vue";
import green from "./green.vue";
import enter from "./enter.vue";

export default {
  data() {
    return {
      // currentComponent: safe,
      currentComponentList: ["safe"],
      middleComponentList: ["worksite", "progressData", "warning"],
      rigthComponentList: ["green", "enter"],
      eqi_tab: ["塔吊检查", "升降机监测", "卸料平台", "基坑监测"],
      eqi_name: "塔吊检查",
      eqiName: "塔吊1",
      eqiNum: "98",
      tower_data: {
        height: "98",
        before: "47",
        after: "98",
        weight: "260",
        power: "26",
        rotation: "53",
        shake: "16",
        drop: "67",
        wind: "6",
        vertical: "45",
        level: "45",
      },
      //timer: null,
      charts: null,
      eqi_totalNum: "5",
      questionNum: "2000",
      finshNum: "1000",
      shouldNum: "60",
      completeNum: "150",
      enterNum: "20002",
      leaveNum: "20002",
      personList: [
        require("./img/enter.png"),
        require("./img/enter1.png"),
        require("./img/leave.png"),
        require("./img/leave1.png"),
      ],
      carList: [
        require("./img/enter_car.png"),
        require("./img/leave_car.png"),
      ],
      carPic: require("./img/enter_car.png"),
      enterPerson: require("./img/enter.png"),
      leavePerson: require("./img/leave.png"),
    };
  },
  mounted() {
    this.renderComponents();
    let data = [910, 800, 98, 118, 208, 10, 900, 110, 55, 11, 121];

    let arrA = [],
      arrB = [];

    for (let i = 0; i < data.length; i++) {
      if (data[i] >= 900) {
        if (arrB.length > 0) {
          arrA.push(arrB);
          arrB = [];
        }
        arrA.push([data[i]]);
        continue;
      }
      if (data[i] + (data[i + 1] || 0) < 900) {
        arrB.push(data[i]);

        if (arrB.length > 2) {
          arrA.push(arrB);
          arrB = [];
        }
        continue;
      }

      if (arrB.length > 0) {
        arrB.push(data[i]);
        arrA.push(arrB);
        arrB = [];
        continue;
      }

      arrA.push([data[i]]);
    }
    arrB.length > 0 && arrA.push(arrB);
    
    // this.chart01();
    // this.chart02();
    // this.chart03();
   
    this.chart06();
    this.chart07();
    // this.env_chart();
    //this.power_chart();
   
  },
  methods: {
   
    // 切换设备
    tabShow(name) {
      this.eqi_name = name;
      this.tower_data = {
        height: Math.floor(Math.random() * (1 - 100) + 100),
        before: Math.floor(Math.random() * (1 - 100) + 100),
        after: Math.floor(Math.random() * (1 - 100) + 100),
        weight: Math.floor(Math.random() * (1 - 100) + 100),
        power: Math.floor(Math.random() * (1 - 100) + 100),
        rotation: Math.floor(Math.random() * (1 - 100) + 100),
        shake: Math.floor(Math.random() * (1 - 100) + 100),
        drop: Math.floor(Math.random() * (1 - 100) + 100),
        wind: Math.floor(Math.random() * (1 - 100) + 100),
        vertical: Math.floor(Math.random() * (1 - 100) + 100),
        level: Math.floor(Math.random() * (1 - 100) + 100),
      };
      this.eqiName = name == "塔吊检查" ? "塔吊" : "升降机";
      this.eqiNum = Math.floor(Math.random() * (1 - 100) + 100);
    },
    chart01() {
      let this_ = this;
      let myChart = this_.$echarts.init(document.getElementById("chart01"));
      let option = {
        color: [
          "rgba(17,80,146,1)",
          "rgba(0,255,249,0.5)",
          "#00FFF9",
          "rgba(0,255,249,0.2)",
        ],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}%",
        },

        series: [
          {
            name: "漏斗图",
            type: "funnel",

            left: "10%",
            top: 30,
            right: "20%",
            //x2: 80,
            bottom: -20,
            width: "85%",
            // height: {totalHeight} - y - y2,
            min: 0,
            max: 70,
            minSize: "0%",
            maxSize: "100%",
            sort: "descending",
            gap: 0,
            label: {
              show: true,
              position: "inside",
            },
            // labelLine: {
            //   length: 10,
            //   lineStyle: {
            //     width: 1,
            //     type: "solid",
            //   },
            // },
            itemStyle: {
              borderColor: "#000712",
              borderWidth: 0,
            },
            emphasis: {
              label: {
                fontSize: 10,
              },
            },
            data: [
              { value: 60, name: "问题发现率85%" },
              { value: 50, name: "整改完成率70%" },
              {
                value: 40,
                name: "订单111",
                itemStyle: {
                  opacity: 0,
                },
                label: {
                  show: false,
                },
                tooltip: {
                  show: false,
                },
              },
              { value: 70, name: "隐患完成率90%" },
            ],
          },
        ],
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    chart02() {
      let this_ = this;
      let myChart = this_.$echarts.init(document.getElementById("chart02"));

      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        color: [
          "rgba(64,146,255,1)",
          "rgba(48,204,49,1)",
          "rgba(202,202,202,1)",
        ],
        grid: {
          left: "8%",
          right: "4%",
          bottom: "3%",
          top: "0",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          show: false,
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
        },
        yAxis: {
          type: "category",
          axisLabel: {
            show: true,
            color: "#fff",
            interval: 0,
          },
          data: ["其他", "临时用电", "动火申请"],
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
        },
        series: [
          {
            name: "直接访问",
            type: "bar",
            stack: "总量",
            barWidth: "70%",
            label: {
              show: true,
              position: "insideRight",
            },
            data: [
              Math.floor(Math.random() * (50 - 80) + 80),
              Math.floor(Math.random() * (40 - 50) + 50),
              Math.floor(Math.random() * (80 - 100) + 100),
            ],
          },
          {
            name: "邮件营销",
            type: "bar",
            stack: "总量",
            barWidth: "70%",
            label: {
              show: true,
              position: "insideRight",
            },
            data: [
              Math.floor(Math.random() * (60 - 80) + 80),
              Math.floor(Math.random() * (50 - 70) + 70),
              Math.floor(Math.random() * (100 - 120) + 120),
            ],
          },
          {
            name: "联盟广告",
            type: "bar",
            stack: "总量",
            barWidth: "70%",
            label: {
              show: true,
              position: "insideRight",
            },
            data: [
              Math.floor(Math.random() * (70 - 80) + 80),
              Math.floor(Math.random() * (100 - 110) + 110),
              Math.floor(Math.random() * (80 - 90) + 90),
            ],
          },
        ],
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    chart03() {
      let this_ = this;
      let myChart = this_.$echarts.init(document.getElementById("chart03"));

      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        color: ["#27D9C8", "#D8D8D8", "yellow"],
        title: {
          text: "一级",
          left: "center",
          top: "52%",
          textStyle: {
            color: "#fff",
            fontSize: 14,
            align: "center",
          },
        },
        graphic: {
          type: "text",
          left: "center",
          top: "40%",
          style: {
            text: "安全教育培训",
            textAlign: "center",
            fill: "#fff",
            fontSize: 12,
            fontWeight: 500,
          },
        },
        series: [
          {
            name: "运动情况",
            type: "pie",
            radius: ["88%", "100%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
            },
            // itemStyle: {
            //   borderWidth: 5, //设置border的宽度有多大
            //   borderColor: "#fff",
            // },

            data: [
              { value: 80, name: "已完成" },
              { value: 20, name: "未完成" },
            ],
          },
        ],
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    chart04() {
      let this_ = this;
      let myChart = this_.$echarts.init(document.getElementById("chart04"));

      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        color: ["#27D9C8", "#D8D8D8", "yellow"],
        title: {
          text: "二级",
          left: "center",
          top: "52%",
          textStyle: {
            color: "#fff",
            fontSize: 14,
            align: "center",
          },
        },
        graphic: {
          type: "text",
          left: "center",
          top: "40%",
          style: {
            text: "安全教育培训",
            textAlign: "center",
            fill: "#fff",
            fontSize: 12,
            fontWeight: 500,
          },
        },
        series: [
          {
            name: "运动情况",
            type: "pie",
            radius: ["88%", "100%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
            },

            data: [
              { value: 65, name: "已完成" },
              { value: 35, name: "未完成" },
            ],
          },
        ],
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    chart05() {
      let this_ = this;
      let myChart = this_.$echarts.init(document.getElementById("chart05"));

      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        color: ["#27D9C8", "#D8D8D8", "yellow"],
        title: {
          text: "三级",
          left: "center",
          top: "52%",
          textStyle: {
            color: "#fff",
            fontSize: 14,
            align: "center",
          },
        },
        graphic: {
          type: "text",
          left: "center",
          top: "40%",
          style: {
            text: "安全教育培训",
            textAlign: "center",
            fill: "#fff",
            fontSize: 12,
            fontWeight: 500,
          },
        },
        series: [
          {
            name: "运动情况",
            type: "pie",
            radius: ["88%", "100%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
            },

            data: [
              { value: 60, name: "已完成" },
              { value: 40, name: "未完成" },
            ],
          },
        ],
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    chart06() {
      let this_ = this;
      let myChart = this_.$echarts.init(document.getElementById("chart06"));

      let option = {
        // tooltip: {
        //   trigger: "item",
        //   formatter: "{a} <br/>{b}: {c} ({d}%)",
        // },
        color: ["#5050FF", "#5E5E5E"],
        title: {
          text: "80%",
          left: "center",
          top: "52%",
          textStyle: {
            color: "#fff",
            fontSize: 12,
            align: "center",
          },
        },
        graphic: {
          type: "text",
          left: "center",
          top: "40%",
          style: {
            text: "劳资金额进度",
            textAlign: "center",
            fill: "#fff",
            fontSize: 12,
            fontWeight: 500,
          },
        },
        series: [
          {
            name: "运动情况",
            type: "pie",
            radius: ["70%", "80%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
            },

            data: [
              { value: 40, name: "已完成" },
              { value: 50, name: "未完成" },
            ],
          },
        ],
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    chart07() {
      let this_ = this;
      let myChart = this_.$echarts.init(document.getElementById("chart07"));

      let option = {
        // tooltip: {
        //   trigger: "item",
        //   formatter: "{a} <br/>{b}: {c} ({d}%)",
        // },
        color: ["#27D9C8", "#5E5E5E"],
        title: {
          text: "85%",
          left: "center",
          top: "52%",
          textStyle: {
            color: "#fff",
            fontSize: 12,
            align: "center",
          },
        },
        graphic: {
          type: "text",
          left: "center",
          top: "40%",
          style: {
            text: "劳资人员进度",
            textAlign: "center",
            fill: "#fff",
            fontSize: 12,
            fontWeight: 500,
          },
        },
        series: [
          {
            name: "运动情况",
            type: "pie",
            radius: ["70%", "80%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
            },

            data: [
              { value: 80, name: "已完成" },
              { value: 20, name: "未完成" },
            ],
          },
        ],
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    env_chart() {
      let this_ = this;
      let myChart = this_.$echarts.init(document.getElementById("env_chart"));
      var dataAxis = ["风速", "风向", "大气压", "温度", "湿度", "噪音"];
      let data = [
        Math.floor(Math.random() * (100 - 200) + 200),
        Math.floor(Math.random() * (70 - 80) + 80),
        Math.floor(Math.random() * (90 - 100) + 100),
        Math.floor(Math.random() * (100 - 170) + 170),
        Math.floor(Math.random() * (50 - 60) + 60),
        Math.floor(Math.random() * (200 - 220) + 220),
      ];
      let yMax = 800;
      let dataShadow = [];
      for (let i = 0; i < data.length; i++) {
        dataShadow.push(yMax);
      }

      let option = {
        xAxis: {
          data: dataAxis,
          axisLabel: {
            textStyle: {
              show: true,
              color: "#fff",
              interval: 0,
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          z: 10,
        },
        grid: {
          left: "-1%",
          right: "4%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#999",
            },
          },
          show: false,
        },

        series: [
          {
            data: [
              Math.floor(Math.random() * (100 - 200) + 200),
              Math.floor(Math.random() * (70 - 80) + 80),
              Math.floor(Math.random() * (90 - 100) + 100),
              Math.floor(Math.random() * (100 - 170) + 170),
              Math.floor(Math.random() * (50 - 60) + 60),
              Math.floor(Math.random() * (200 - 220) + 220),
            ],
            type: "bar",
            showBackground: true,
            barWidth: "24px",
            itemStyle: {
              normal: {
                color: function (params) {
                  let colorList = [
                    "rgba(254,66,65,1)",
                    "rgba(83,164,102,1)",
                    "rgba(3,117,255,1)",
                    "rgba(3,117,255,1)",
                  ];
                  return colorList[params.dataIndex];
                },
                label: {
                  show: true,
                  textStyle: {
                    fontWeight: "bolder",
                    fontSize: "12",
                    fontFamily: "微软雅黑",
                    color: "#fff",
                  },
                  formatter: function (params) {
                    let text = ["24m/s", "35%", "67dB", "28℃", "36%", "67dB"];
                    return text[params.dataIndex];
                  },
                  position: "top",
                },
              },
            },

            backgroundStyle: {
              color: "rgba(220, 220, 220, 0.8)",
            },
          },
          // {
          //   // For shadow
          //   type: "bar",
          //   itemStyle: {
          //     normal: {
          //       color: "#FFFFFF",
          //     },
          //   },
          //   barGap: "-100%",
          //   barCategoryGap: "40%",
          //   data: dataShadow,
          //   // animation: false,
          //   barWidth: "24px",
          // },
          // {
          //   type: "bar",
          //   itemStyle: {
          //     normal: {
          //       color: "#4F74FF",
          //     },
          //   },
          //   data: data,
          //   barWidth: "24px",
          // },
        ],
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    //格式化时间
    formatDate(date, fmt) {
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    },

    // 动态渲染组件
    renderComponents() {
      let list = ["safe", "worksite"];
      let data = [];
      list.forEach((item) => {
        let route = {
          name: item,
          component: () => import("./" + item + ".vue"),
        };
        data.push(route);
      });
    },
  },
  created() {},
  components: {
    safe,
    worksite,
    progressData,
    warning,
    green,
    enter,
  },
};
</script>
<style scss scoped>
  @import "./css/home.scss";
  @import "./css/common.scss";
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->

